const Form017SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申请资料",
        confirmation: "确认",
    },
    label: {
        note: {
            title: "提示",
            note1: "申请者请准备以格式JPG, PNG或 PDF的有关文件档案：",
            note2: "(所有文件的总大小不可超过10MB)",
            note3: "申请者需透过已启用数码签署功能的「智方便」帐户，以办理网上递交申报表。",
            note4: "请谨记列印申请表，并将学校发展资料册一式两份，经由以下方法递交：",
            note5: "以专人递交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部〈请在递交日期最少2个工作天前致电3509 7471登记预约〉；",
            note5a: "或",
            note6: "以挂号邮件寄交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部学校领导及专业发展组收",
        },
        termsConditions: "本人已阅读、理解及同意上述条款及条件。",
        iamSignCheck: "本人理解申请人需要拥有「智方便+」帐户才能处理申请。",
        refNo: "档案编号：",
        refNo2: "(只供部门使用)",
        nameOfApplicanEn:
            "申请人姓名（须与申请人之香港身份证上所载相同）(英文)",
        nameOfApplicanCh:
            "申请人姓名（须与申请人之香港身份证上所载相同）(中文)",
        correspondenceAddress: "通讯地址",
        contactTelephone: "电话号码(学校/办公室)",
        schoolOrOfficeOption: {
            school: "学校电话号码",
            office: "办公室电话号码",
        },
        contactTelephoneNo: "电话号码(住宅/手提)",
        HomeOrMobileOption: {
            home: "住宅电话号码",
            mobile: "手提电话号码",
        },
        faxNo: "传真号码",
        emailAddress: "电邮地址",
        hKIdentityCardOrPassportNo: "香港身份证/护照号码",
        hKIdentityCardOrPassportNoOption: {
            hkic: "香港身份证号码",
            passport: "护照号码",
        },
        registeredTeacherOrPermittedTeacher: "检定教员/准用教员编号",
        registeredTeacherOrPermittedTeacherOption: {
            registeredTeacher: "检定教员编号",
            permittedTeacher: "准用教員编号",
        },
        appointmentToPrincipalship: "已获聘任为校长",
        noteList:
        "申请人未能提交此申请。",
        noteList1:"如你的校长资格认证已经过期，而希望在获聘为校长前持有有效认证，可申请重新开展校长资格认证程序。",
        confirm: "confirm",
        appointmentToPrincipalshipOption: {
            yes: "是",
            no: "否",
        },
        dateOfAppointmentToPrincipalship: "到任日期",
        schoolOrganisation: "申請人所属学校/机构",
        schoolOrganisationOption: {
            school: "申请人所属学校",
            organisation: "申请人所属机构",
        },
        name: "学校名称",
        address: "学校地址",
        name1: "机构名称",
        address1: "机构地址",
        typeOfSchool: "学校类别（如适用）",
        typeOfSchoolOption1: {
            primary: "小学",
            secondary: "中学",
            special: "特殊学校",
        },
        typeOfSchoolOption2: {
            government: "官立",
            aided: "资助",
            dss: "直资",
            caput: "按额资助",
            others: "其他(请说明)",
        },
        // typeOfSchoolOption: {
        //     primary: "小学",
        //     secondary: "中学",
        //     special: "特殊学校",
        //     government: "官立",
        //     aided: "资助",
        //     dss: "直资",
        //     caput: "按额资助",
        //     others: "其他（请说明）",
        // },
        specify: "请说明",
        issueDateOfCFP: "发出校长资格认证日期",
        header: "请在适当的方格内填上 √",

        declaration: "声明",
        note1: "",
        // declarationContentList: [
        //     "本人已阅读及明白 「 学校发展资料册撰写指引 」；",
        //     "本人在申请表填写的个人资料，以及就本次申请呈交的学校发展资料册当中的所有事实资料 ，均属真实准确；以及",
        //     "本学校发展资料册的内容，除引用其他来源资料的部分以外，全属本人作品，而所引用的其他来源资料，其出处已妥为注明，所抄录的部分亦以引文方式标示；本学校发展资料册符合版权法例#。",
        // ],
        declaration1: "本人已阅读及明白 「 学校发展资料册撰写指引 」",
        declaration2:
            "本人在申请表填写的个人资料，以及就本次申请呈交的学校发展资料册当中的所有事实资料 ，均属真实准确；以及",
        declaration3:
            "本学校发展资料册的内容，除引用其他来源资料的部分以外，全属本人作品，而所引用的其他来源资料，其出处已妥为注明，所抄录的部分亦以引文方式标示；本学校发展资料册符合版权法例",

        errorMsg: {
            nameOfApplicanEn: "请输入一个有效的申请人姓名(英文)",
            nameOfApplicanCh: "请输入一个有效的申请人姓名(中文)",
            correspondenceAddress: "请输入一个有效的通讯地址",
            school: "请输入一个有效的学校电话号码",
            office: "请输入一个有效的办公室电话号码",
            home: "请输入一个有效的住宅电话号码",
            mobile: "请输入一个有效的手提电话号码",
            faxNo: "请输入一个有效的传真号码",
            emailAddress: "请输入一个有效的电邮地址",
            hkic: "请输入一个有效的香港身份证",
            passport: "请输入一个有效的护照号码",
            registeredTeacher: "请输入一个有效的检定教员编号",
            permittedTeacher: "请输入一个有效的准用教员编号",
            dateOfAppointmentToPrincipalship: "请输入一个今天之前或之后的日期",
            name: "请输入一个有效的学校名称",
            address: "请输入一个有效的学校地址",
            name1: "请输入一个有效的机构名称",
            address1: "请输入一个有效的机构地址",
            issueDateOfCFP: "请输入一个有效的发出校长资格认证日期",
            otherInput: "请输入一个有效的原因",
            E0001: "如果你选择其他，请写明原因",
        },
        attachment: "附件",
        completedByEDB: "此栏由教育局填写",
    },
    submittedDialog: {
        note1: "已成功递交申请。",
        note2: "请谨记列印",
        note3: "此表格",
        note4: "，并将",
        note5: "学校发展资料册一式两份",
        note6: "，经由以下方法递交： ",
        note7: "以专人递交至香港添马添美道2号政府总部东翼5楼教育局专业发展及培训分部〈请在递交日期最少2个工作天前致电3509 7471登记预约〉；或",
        note8: "以挂号邮件寄交至",
        note9: "香港添马添美道2号",
        note10: "政府总部东翼5楼",
        note11: "教育局",
        note12: "专业发展及培训分部",
        note13: "学校领导及专业发展组收",
    },
};
export default Form017SC;
